import React from "react"
import * as styles from "../content/content.module.scss"
import parse from "html-react-parser";
import {GatsbyImage, getImage} from "gatsby-plugin-image";

const BlogContent = ({title, desc, image, cta}) => {

    let description = '';
    if (desc !== null) {
        description = parse(desc);
    }
    let contentImage = '';
    let contentImageType = '';
    let figureClass = '';
    let contentImgAlt = '';
    if (image !== null) {
        contentImage = getImage(image.node.localFile);

        const imgTitle = image.node.title ? image.node.title : title;
        const imgAltText = image.node.altText ? image.node.altText : imgTitle;

        let types = ['png', 'gif', 'svg'];
        if (types.includes(contentImageType)) {
            figureClass = `${styles.contentImageTransparent}`
        }

        if (contentImage !== undefined) {
            contentImgAlt = imgAltText;
        }
    }

    return (
        <section className={styles.contentSection}>
            <div className="grid-container-wrap">
                <div className={styles.gridContent}>

                    {image &&
                    <div className={styles.gridContentImg}>
                        <figure className={figureClass}>
                            <GatsbyImage image={contentImage} alt={contentImgAlt}/>
                        </figure>
                    </div>
                    }

                    <div className={styles.gridContentText}>
                        {title && <h2>{title}</h2>}
                        {description}

                        {cta &&
                        <a href={cta.url} target={cta.target} className="btn btn-primary">
                            {cta.title ? cta.title : `Lees meer`}
                        </a>
                        }

                    </div>
                </div>
            </div>
        </section>
    )
}

export default BlogContent